// Vietnamese Translation
export default {
  // Navigation
  navHome: 'Trang chủ',
  navMethod: 'Phương pháp TSMC',
  navServices: 'Dịch vụ',
  navAbout: 'Về chúng tôi',
  navFaq: 'Câu hỏi',
  navContact: 'Liên hệ & Đặt lịch',
  navBlog: 'BLOG',
  
  // Buttons
  bookNow: 'Đặt lịch ngay',
  lineConsult: 'Tư vấn LINE',
  bookNowFull: 'Đặt lịch ngay',
  
  // Hero
  heroTitle1: 'Độ chính xác của kỹ sư',
  heroTitle2: 'Phục hồi cấu trúc cơ thể',
  heroSubtitle: 'Chiropractic & Massage Thể thao Chuyên nghiệp Tainan Jiali',
  heroDesc: 'Tích hợp Kỹ thuật Hàng đầu từ Mỹ, Nhật Bản, Úc, Canada | Giải phóng Fascia Sâu | Cơ học Cấu trúc',
  heroCert: 'Chứng chỉ Đa quốc gia',
  heroPrice: 'Giá Minh bạch',
  heroTime: 'Mở cửa Thứ 7-Thứ 4',
  
  // What is Chiropractic
  whatIsTitle: 'Chiropractic Mỹ',
  whatIsChiro: 'là gì',
  whatIsSubtitle: "Chiropractic schools and manual traditions",
  whatIsPara1: "In some international systems, ",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: " is a manual tradition that originated in the United States and was founded by ",
  whatIsFounder: 'Daniel David Palmer',
  whatIsPara1c: " in 1895. The following describes that school’s perspective.",
  whatIsPara2: "Within that tradition, specific manual methods are used to consider joint movement and whole-body use, ",
  whatIsRestore: "with adjustments guided by personal comfort",
  whatIsPara2b: "; this is not a disease diagnosis, medical treatment, or guarantee of a specific result.",
  whatIsBoxTitle: "Understanding daily body use as a whole",
  whatIsBoxDesc: "This approach considers daily loading, movement habits, and how different areas work together:",
  whatIsCycle1: "Repeated demands from work or exercise",
  whatIsCycle2: "Muscle tension and movement habits can influence each other",
  whatIsCycle3: "Different areas coordinate and compensate during movement",
  whatIsCycle4: "Look at everyday body use from a whole-body perspective",
  chiroCardTitle: 'Chiropractic Mỹ',
  chiroCardDesc: 'Chuyên về',
  chiroCardFocus: 'điều chỉnh xương',
  chiroCardDesc2: ', khôi phục khả năng vận động bình thường của khớp thông qua các kỹ thuật chính xác',
  massageCardTitle: 'Massage Thể thao',
  massageCardDesc: 'Chuyên về',
  massageCardFocus: 'thư giãn cơ',
  massageCardDesc2: ', giải phóng căng thẳng fascia sâu và cải thiện mất cân bằng cơ',
  whatIsSummary: 'TSMC kết hợp cả hai phương pháp',
  whatIsSummary2: ', xác định hệ thống nào đang gây ra vấn đề và áp dụng kỹ thuật phù hợp, xem xét toàn diện "nguyên nhân" và "phòng ngừa" dựa trên cơ học và cấu trúc',
  
  // TSMC Method
  methodTitle: 'TSMC',
  methodTitleSuffix: 'Phương pháp',
  methodSubtitle: 'Hệ thống Điều chỉnh Cấu trúc Cơ thể Độc quyền của TSMC',
  methodT: 'Technology',
  methodTSub: 'Tích hợp Kỹ thuật Đa quốc gia',
  methodTDesc: 'Kết hợp các kỹ thuật chiropractic hàng đầu từ Mỹ, Nhật Bản, Úc, Canada để chăm sóc toàn diện',
  methodS: 'Stretching',
  methodSSub: 'Kéo giãn & Điều chỉnh Cấu trúc',
  methodSDesc: 'Cải thiện có hệ thống cấu trúc cơ thể mất cân bằng từ cột sống, xương chậu đến các khớp tay chân',
  methodM: 'Mobility',
  methodMSub: 'Tối ưu hóa Khả năng Vận động',
  methodMDesc: 'Nhắm vào cơ và fascia sâu để tăng cường phạm vi chuyển động và độ linh hoạt của khớp',
  methodC: 'Chiro',
  methodCSub: 'Chiropractic Cá nhân hóa',
  methodCDesc: 'Thiết kế kế hoạch chăm sóc cá nhân hóa dựa trên thể trạng, triệu chứng và lối sống của từng người',
  methodSystemTitle: 'Cơ thể là một Hệ thống Sinh cơ học Chính xác',
  methodSystem1: 'Xương kết nối với cơ, cơ kéo xương',
  methodSystem2: 'Cơ tạo ra lực, hỗ trợ xương, xương hỗ trợ toàn bộ cơ thể',
  methodSystem3: 'Chống lại trọng lực và đáp ứng với các lực khác nhau trong cuộc sống',
  
  // Services
  services: 'Dịch vụ Chuyên nghiệp',
  servicesDesc: 'Chăm sóc Kép - Chiropractic Mỹ + Massage Thể thao',
  chiro: 'Chiropractic Mỹ',
  chiroService: "Specific manual methods · Daily movement care · Body awareness",
  chiroFeature1: "Manual methods adjusted to personal comfort",
  chiroFeature2: "Consider everyday movement and body-use habits",
  chiroFeature3: "Daily care for seated, standing, and physical-work lifestyles",
  chiroPrice: '$1000',
  chiroPriceSuffix: 'trở lên / 30-40 phút',
  massage: 'Chiropractic Mỹ + Massage Thể thao',
  massageService: "Manual care · Deep fascial relaxation · Post-exercise care",
  massageFeature1: "Deep muscle and fascial relaxation based on personal needs",
  massageFeature2: "Post-exercise relaxation for regularly active people",
  massageFeature3: "Whole-body relaxation for office and physical workers",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 phút',
  suitable: 'Phù hợp cho:',
  chiroSuitable: "office workers, standing workers, physical workers, and people who value daily body care",
  massageSuitable: "active people, office workers, physical workers, and those seeking post-exercise relaxation",
  
  // Services Summary
  servicesSummary1: "Two-track bodywork: manual care + massage",
  servicesSummary2: ", tailored to lifestyle and everyday relaxation needs",
  
  // Who Needs Our Services
  whoNeedsTitle: "Lối sống nào phù hợp với chăm sóc cơ thể hằng ngày?",
  whoNeedsSubtitle: "Phân nhóm theo lối sống và cách sử dụng cơ thể, không theo chẩn đoán hay điều trị bệnh",
  
  // Target Groups
  targetOffice: "Nhóm làm việc văn phòng",
  targetOfficeSymptom1: "Làm việc máy tính nhiều giờ",
  targetOfficeSymptom2: "Ít vận động hằng ngày",
  targetOfficeSymptom3: "Giữ một tư thế trong thời gian dài",
  targetOfficeSymptom4: "Muốn thư giãn cổ, vai và lưng hằng ngày",
  
  targetAthlete: "Nhóm vận động thường xuyên",
  targetAthleteSymptom1: "Tập sức mạnh hoặc thể thao bóng",
  targetAthleteSymptom2: "Muốn thư giãn sau vận động",
  targetAthleteSymptom3: "Chú trọng giãn cơ và chăm sóc hằng ngày",
  targetAthleteSymptom4: "Muốn hiểu thói quen sử dụng cơ thể",
  
  targetPosture: "Nhóm làm việc đứng lâu",
  targetPostureSymptom1: "Công việc cần đứng lâu",
  targetPostureSymptom2: "Đi lại nhiều hoặc giữ một tư thế",
  targetPostureSymptom3: "Sử dụng chân nhiều hằng ngày",
  targetPostureSymptom4: "Muốn thư giãn chân và toàn thân",
  
  targetChronic: "Nhóm lao động thể lực",
  targetChronicSymptom1: "Thường xuyên nâng hoặc mang đồ",
  targetChronicSymptom2: "Lặp lại cùng một động tác lâu dài",
  targetChronicSymptom3: "Khối lượng vận động hằng ngày cao",
  targetChronicSymptom4: "Muốn thư giãn cơ toàn thân",
  
  targetSenior: "Nhóm đi lại và lái xe",
  targetSeniorSymptom1: "Lái xe hoặc đi xe nhiều giờ mỗi ngày",
  targetSeniorSymptom2: "Thường xuyên đi làm xa hoặc di chuyển đường dài",
  targetSeniorSymptom3: "Công việc đòi hỏi giữ tư thế lái xe cố định",
  targetSeniorSymptom4: "Muốn thư giãn toàn thân trong thời gian nghỉ",
  
  targetPregnant: "Nhóm chăm sóc cơ thể định kỳ",
  targetPregnantSymptom1: "Không có nhu cầu điều trị bệnh cụ thể",
  targetPregnantSymptom2: "Chú trọng thư giãn và tự chăm sóc",
  targetPregnantSymptom3: "Muốn hiểu thói quen vận động hằng ngày",
  targetPregnantSymptom4: "Sắp xếp chăm sóc cơ thể định kỳ",
  
  // About Us
  aboutTitle: 'Từ Kỹ sư đến Chuyên gia Điều chỉnh Cơ thể',
  aboutSubtitle: 'Triết lý và Phương pháp',
  aboutPara1: 'Tư duy của kỹ sư là theo đuổi',
  aboutPara1Highlight: '"giải quyết vấn đề từ gốc rễ"',
  aboutPara1b: '. Giống như debug code, chúng tôi không chỉ xử lý triệu chứng đau mà tìm ra nguyên nhân gốc rễ của mất cân bằng cấu trúc.',
  aboutPara2: 'Mỗi lần điều chỉnh giống như biên dịch lại mã cấu trúc của cơ thể. Chúng tôi kết hợp các kỹ thuật hàng đầu từ',
  aboutPara2Highlight: 'Mỹ, Nhật Bản, Úc và Canada',
  aboutPara2b: ', sử dụng độ chính xác của kỹ sư để mang lại tối ưu hóa sâu nhất cho cơ thể bạn.',
  aboutPara3: 'Tại Jiali, Tainan, chúng tôi cung cấp nhiều hơn massage truyền thống. Chúng tôi mang đến',
  aboutPara3Highlight: 'chăm sóc cơ thể có hệ thống',
  aboutPara3b: ' kết hợp giải phẫu hiện đại, sinh cơ học và khoa học thể thao.',
  aboutQuote: 'Cơ thể là một hệ thống sinh cơ học chính xác. Điều cần thiết không phải là sửa chữa tạm thời mà là tái thiết cấu trúc có hệ thống. Chúng tôi sử dụng tư duy logic của kỹ sư cùng với kỹ thuật chuyên nghiệp để giúp mỗi khách hàng lấy lại trạng thái tối ưu của cơ thể.',
  aboutQuoteAuthor: '— Người sáng lập TSMC',
  
  // FAQ
  faqTitle: 'Câu hỏi Thường gặp',
  faqSubtitle: 'Về Tainan Jiali Chiropractic & Massage',
  
  // FAQ Q&A
  faq1Q: 'Chiropractic Mỹ khác gì với massage truyền thống?',
  faq1A: 'Chiropractic Mỹ tập trung vào "căn chỉnh khớp xương", khôi phục khả năng vận động bình thường của khớp thông qua các kỹ thuật chính xác để cải thiện cơ học cơ thể một cách căn bản. Massage truyền thống tập trung vào thông kinh lạc và thư giãn cơ. TSMC kết hợp cả hai để chăm sóc toàn diện.',
  
  faq2Q: 'Có không thoải mái không? An toàn không?',
  faq2A: 'Kỹ thuật của chúng tôi được đào tạo chuyên nghiệp. Bạn có thể cảm thấy hơi kéo giãn hoặc áp lực nhẹ, nhưng sẽ không gây đau. Tất cả các thao tác đều nằm trong giới hạn an toàn và được điều chỉnh theo tình trạng của bạn.',
  
  faq3Q: 'Bao lâu tôi nên đến một lần?',
  faq3A: 'Tùy thuộc vào tình trạng cá nhân. Đối với giai đoạn cấp tính, khuyến nghị 1-2 lần mỗi tuần. Đối với vấn đề mãn tính, ban đầu có thể cần điều trị thường xuyên hơn (một lần mỗi tuần), sau đó có thể kéo dài đến 2-4 tuần một lần để bảo dưỡng. Chúng tôi sẽ đưa ra lời khuyên chuyên nghiệp dựa trên tình trạng của bạn.',
  
  faq4Q: 'Lần đầu đến tôi cần mang gì?',
  faq4A: 'Khuyến nghị mặc quần áo thoải mái và rộng rãi. Nếu đã từng có kiểm tra cơ thể (X-quang, MRI, v.v.), vui lòng mang theo để tham khảo. Chúng tôi sẽ tiến hành đánh giá cơ thể chi tiết trước khi thiết kế kế hoạch chăm sóc cá nhân hóa.',
  
  faq5Q: 'Giá của bạn tính như thế nào?',
  faq5A: 'Chiropractic Mỹ bắt đầu từ $1000 (30-40 phút), Chiropractic + Massage Thể thao $2300 (90 phút). Giá cả minh bạch không có phí ẩn. Đối với người lần đầu trải nghiệm, chúng tôi khuyến nghị bắt đầu với Chiropractic Mỹ để đánh giá tình trạng của bạn, sau đó đề xuất dịch vụ phù hợp.',
  
  faq6Q: 'Tôi có thể đến từ ngoài Tainan Jiali không?',
  faq6A: 'Tất nhiên! Chúng tôi phục vụ khách hàng từ tất cả các khu vực của Tainan, bao gồm Jiali, Madou, Xuejia, Jiangjun, Qigu, Xigang, Anding, v.v. Giao thông thuận tiện với điều hướng Google Maps.',
  
  // Reviews
  reviewsTitle: 'Phản hồi Thực tế từ Khách hàng',
  reviewsSubtitle: 'Từ Các Khách hàng Quý giá với Đánh giá 5 Sao',
  reviewsDisclaimer: 'TSMC không phải là cơ sở y tế. Các trích đoạn đánh giá của khách hàng trên Google dưới đây chỉ phản ánh trải nghiệm cá nhân của người đánh giá và không phải là tuyên bố hay bảo đảm của TSMC về hiệu quả y tế hoặc dịch vụ.',
  reviewsViewAll: 'Xem Tất cả Đánh giá Google',
  reviewsFrom: 'Nguồn',
  
  // Training
  trainingTitle: 'Đào tạo Quốc tế',
  trainingSubtitle: 'Phát triển Chuyên nghiệp Liên tục',
  trainingIntro: 'Trong những năm qua, liên tục học hỏi từ các giảng viên chuyên nghiệp trên toàn thế giới, không ngừng nâng cao chuyên môn kỹ thuật và mang các khái niệm chiropractic tiên tiến về Đài Loan.',
  trainingYear: '',
  trainingStats1: 'Học tập Liên tục',
  trainingStats1Val: '10+ Năm',
  trainingStats2: 'Giảng viên Quốc tế',
  trainingStats2Val: '10+ Bậc thầy',
  trainingStats3: 'Đào tạo Xuyên biên giới',
  trainingStats3Val: 'Nhiều Lần',
  
  // CTA
  ctaTitle: "Sẵn sàng dành thời gian chăm sóc cơ thể?",
  ctaDesc: "Chọn dịch vụ bodywork phi y tế theo lối sống và nhu cầu thư giãn",
  ctaBooking: 'Đặt lịch Online',
  ctaLine: 'Tư vấn Trực tuyến LINE',
  ctaTransparent: 'Giá Minh bạch',
  ctaTransparentDesc: 'Không Phí Ẩn\nGiá Rõ ràng',
  ctaCert: 'Được Chứng nhận Chuyên nghiệp',
  ctaCertDesc: 'Kỹ thuật Đa\nQuốc gia',
  ctaFlex: 'Đặt lịch Linh hoạt',
  ctaFlexDesc: 'Hệ thống Trực tuyến\nNhanh & Dễ dàng',
  
  // Footer
  footerHours: 'Giờ Làm việc',
  footerHoursDays: 'Thứ Bảy đến Thứ Tư',
  footerHoursTime: '11:00 AM - 9:40 PM',
  footerHoursClosed: 'Đóng cửa Thứ Năm & Thứ Sáu',
  footerLocation: 'Vị trí',
  footerLocationCity: 'Quận Jiali, Thành phố Tainan',
  footerLocationAddr: 'Số 130-95, Anxi, Làng Wenxin',
  footerLocationMap: 'Dẫn đường Google Maps',
  footerLocationSearch: 'Mở trực tiếp vị trí TSMC Chiro Studio trên Google Maps',
  footerLocationGuide: 'Không cần tự tìm địa chỉ. Nhấn nút bên dưới để được dẫn đường trực tiếp.',
  footerLocationOpenMap: 'Mở Chỉ đường Google Maps Trực tiếp',
  footerContact: 'Liên hệ',
  footerContactLine: 'Tài khoản LINE Chính thức',
  footerFollow: 'Theo dõi Chúng tôi',
  footerServices: 'Dịch vụ',
  footerService1: 'Chiropractic Mỹ',
  footerService2: 'Cải thiện Khả năng Vận động Khớp',
  footerService3: 'Massage Thể thao',
  footerService4: 'Giải phóng Fascia Sâu',
  footerService5: 'Điều chỉnh Xương chậu',
  footerService6: 'Đánh giá & Tối ưu hóa Tư thế',
  footerDisclaimer: 'Thông báo Quan trọng:',
  footerDisclaimerText: "TSMC cung cấp bodywork truyền thống và massage thể thao phi y tế nhằm thư giãn, chăm sóc cơ thể và nâng cao nhận thức cơ thể. Chúng tôi không chẩn đoán, điều trị bệnh hoặc phục hồi chức năng. Nếu đau kéo dài, tê yếu, chóng mặt, chấn thương cấp hoặc nghi ngờ bệnh lý, vui lòng gặp bác sĩ có giấy phép trước.",
  footerBookingBtn: '🎯 Đặt lịch Online Ngay',
  footerCopyright: '© 2026 TSMC - Studio Chiropractic & Massage Thể thao Chuyên nghiệp Tainan Jiali',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · Chiropractic & Massage Thể thao Chuyên nghiệp',

  
  // Service Flow
  serviceFlowTitle: 'Quy Trình Dịch Vụ của Chúng Tôi',
  serviceFlowSubtitle: 'Từ đánh giá chuyên nghiệp đến điều chỉnh chính xác, mỗi bước đảm bảo sức khỏe của bạn',
  serviceFlowPhase1: 'Giai Đoạn Đánh Giá',
  serviceFlowPhase2: 'Giai Đoạn Điều Chỉnh',
  serviceFlowScrollHint: 'Cuộn để xem quy trình đầy đủ',
  step1Title: 'Quan Sát Vận Động Cá Nhân',
  step1Desc: 'Quan sát một số động tác theo mức độ thoải mái của từng người để hiểu hoạt động hằng ngày và cách sử dụng cơ thể',
  step2Title: 'Đánh Giá Độ Dài Chân',
  step2Desc: 'Đo chính xác sự khác biệt chiều dài xương chậu và chi dưới để xác định mất cân bằng cấu trúc',
  step3Title: 'Kiểm Tra Bàn Chân',
  step3Desc: 'Kiểm tra phân bố áp lực bàn chân và trạng thái vòm chân để đánh giá vấn đề dáng đi',
  step4Title: 'Kiểm Tra Áp Lực',
  step4Desc: 'Đánh giá căng thẳng cơ và khả năng vận động khớp để xác nhận vùng có vấn đề',
  step5Title: 'Điều Chỉnh Lưng',
  step5Desc: 'Giải phóng cân mạc cơ sâu để cải thiện mất cân bằng căng thẳng cơ lưng',
  step6Title: 'Điều Chỉnh Cổ & Vai',
  step6Desc: 'Điều chỉnh chính xác cho cứng cổ và vai để khôi phục khả năng vận động',
  step7Title: 'Kiểm Tra Hoàn Chỉnh',
  step7Desc: 'Đánh giá lại sau phiên làm việc để xác nhận cải thiện và đưa ra khuyến nghị tiếp theo'
};
